import _ from 'lodash';
import CalculatorSelectInput from '../../../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';
import CalculatorStandardInput from '../../../../calculatorInputs/CalculatorStandardInput';
import React from 'react';

const EqualValue = ({ availableValueOptions, fieldName, showLabel, readOnly = false}) => {
  const label = showLabel
    ? i18next.t('calculator.dialog.create.label.values')
    : '';

  const placeholder = i18next.t(
    'calculator.dialog.create.placeholder.selectValues'
  );

  const commonProps = {
    fieldName: `${fieldName}.0`,
    label,
    placeholder,
    isRequired: true,
    validate: () => null,
    uxVariant: 'criteriaInput',
    variant: 'standard',
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorSelectInput
      {...commonProps}
      options={availableValueOptions}
      validate={() =>  null}
      labelVariant="chip"
      triggerOnContinue
      disabled={readOnly}
    />
  ) : (
    <CalculatorStandardInput
      {...commonProps}
      validate={() => null}
      triggerOnContinue
      disabled={readOnly}
    />)

}

export default EqualValue;